export default "__VITE_ASSET__D0BgjM5m__"